import * as AT from "./actionTypes";
import { ClientSideConfig } from "../../../../models";
import { Appearance, AppearancePreference } from "../../../../shared/appearance";

export const initializeData = (data: ClientSideConfig) => ({
    type: AT.CONFIG_INITIALIZE_CONFIG,
    value: data,
});

export const setAppearance = (appearance: AppearancePreference) => ({
    type: AT.CONFIG_SET_APPEARANCE,
    value: appearance,
});

export const setSystemAppearance = (appearance: Appearance) => ({
    type: AT.CONFIG_SET_SYSTEM_APPEARANCE,
    value: appearance,
});
